import { gsap, ScrollTrigger, clickNav, fadeUpOnScroll } from '../layout';

document.addEventListener("DOMContentLoaded", function(){
	clickNav();
	fadeUpOnScroll();

    const singleBanner = document.querySelector('.single-banner').offsetHeight;
    const wrapper = document.querySelector('.single-banner__wrapper');
    wrapper.style.height = singleBanner - (singleBanner * 0.4) + 'px';
})